<template>
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <rect x="0.111115" y="19.8889" width="7" height="20" rx="0.638889" transform="rotate(-90 0.111115 19.8889)" fill="currentColor" />
        <circle cx="10.5" cy="6.50003" r="6.38889" transform="rotate(-90 10.5 6.50003)" fill="currentColor" />
    </svg>
</template>
